const sessionKey = 'povli_session_id'

export function getSessionId(): string {
  try {
    const stored = sessionStorage.getItem(sessionKey)
    if (stored) return stored
    const created = crypto.randomUUID()
    sessionStorage.setItem(sessionKey, created)
    return created
  } catch {
    return crypto.randomUUID()
  }
}
